import { render, staticRenderFns } from "./IconExpand.vue?vue&type=template&id=5963a669&"
import script from "./IconExpand.vue?vue&type=script&lang=js&"
export * from "./IconExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports